import Presentation from "./presentation";

const TabEmptyState = () => {
	return (
		<Presentation />
	);
};

export default TabEmptyState;